import { ShimmerText, ShimmerTitle } from '../components/Shimmer'
import React from 'react'
import { CircularProgress } from '@mui/material'
import styled from '@emotion/styled'

const S = {
  Wrapper: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
}

const HomeLoading = () => (
  <>
    <S.Wrapper>
      <CircularProgress />
    </S.Wrapper>
  </>
)

export default HomeLoading
